<template>
  <div id="form">
    <div id="headerText" v-if="!viewAlert && !viewProgress">
      <p id="firstMessage">Formulario autodiagnóstico de condiciones para el teletrabajo</p>
    </div>

    <div v-if="!viewAlert && !viewProgress">
      <label for="" class="myLabel">{{titles[position]}}</label><br>
      <input type="range" name="" min="0" max="9" step="1"  :value="position" id="" disabled>
    </div>

    <!--Aca empiezan los forms-->
    <div style="width:790px;" v-if="!viewProgress">
      <!--Mensaje de Bienvenida-->
      <div id="firstStep" v-if="position == 0" style="display: flex; justify-content: center; align-items: center; flex-direction: column;">
        <p id="secondMessage">
          Hola {{project.first_name}},  como parte del proceso en {{client}}, te invitamos a realizar el siguiente formulario. 
          Esta información será utilizada para entender tus condiciones para el teletrabajo
        </p>
        <p id="secondMessage">Si tienes alguna duda, puedes comunicarte con nosotros al número (+57) 320 472 59 21 o en <a href="www.globalwork.co">www.globalwork.co</a></p>
      </div>
      <!--Primer Formulario-->
      <div v-if="position == 1">
        <label for="" class="myLabel">Nombre</label>
        <input v-model="candidate.first_name" class="myImput" type="text" name="" id="">
        <label for="" class="myLabel">Apellido</label>
        <input v-model="candidate.last_name" class="myImput" type="text" name="" id="">
        <label for="" class="myLabel">Cargo postulado</label>
        <input v-model="candidate.current_activity" class="myImput" type="text" name="" id="">
        <label for="" class="myLabel">Estado civil</label>
        <select v-model="candidate.civil_type" class="myImput" name="" id="">
          <option v-for="r in relationship" :value="r.id" :key="r.id">
            {{r.name}}
          </option>
        </select>
        <label for="" class="myLabel">Fecha de namiciento</label>
        <input v-model="candidate.birth_date" class="myImput" type="date" name="" id="">
      </div>
      <!--Segundo Formulario-->
      <div v-if="position == 2">
        <label for="" class="myLabel">Dirección de residencia</label>
        <input v-model="candidate.address" class="myImput" type="text" name="" id="">
        <label for="" class="myLabel">Ciudad de residencia</label>
        <autocomplete :model.sync="candidate.city_id" :items="cities"/>
        <label for="" class="myLabel">Barrio/Localidad</label>
        <input v-model="candidate.neighborhood" class="myImput" type="text" name="" id="">
        <label for="" class="myLabel">Email</label>
        <input v-model="candidate.email_1" class="myImput" type="text" name="" id="">
        <label for="" class="myLabel">Telefono</label>
        <input v-model="candidate.telephone_1" class="myImput" type="text" name="" id="">
      </div>
      <!--Tercer Formulario-->
      <div v-if="position == 3">
        <label for="" class="myLabel">Nombre Completo</label>
        <input v-model="family_member.name" class="myImput" type="text" name="" id="">
        <div style="margin:24px; display:flex; justify-content: space-between;">
          <div style="display: flex; justify-content: center; align-items: normal; flex-direction: column;">
            <label for="">Edad</label>
            <input v-model="family_member.age" class="myImput" type="text" name="" id="">
          </div>
          <div  style="display: flex; justify-content: center; align-items: normal; flex-direction: column;">
            <label for="">Parentesco</label>
            <select v-model="family_member.relation" class="myImput" name="" id="">
              <option v-for="r in familyRelations" :value="r.id" :key="r.id">
                {{r.name}}
              </option>
            </select>
          </div>
        </div>
        <label for="" class="myLabel">Estado Civil</label>
        <select v-model="family_member.civil_state" class="myImput" name="" id="">
          <option v-for="r in relationship" :value="r.id" :key="r.id">
            {{r.name}}
          </option>
        </select>
        <label for="" class="myLabel">Ocupación</label>
        <input v-model="family_member.occupation" class="myImput" type="text" name="" id="">
        <div style="margin:24px; display:flex; justify-content: space-between;">
          <div style="display: flex; justify-content: center; align-items: normal; flex-direction: column;">
            <label for="">Empresa</label>
            <input v-model="family_member.company" class="myImput" type="text" name="" id="">
          </div>
          <div style="display: flex; justify-content: center; align-items: normal; flex-direction: column;">
            <label for="">Antigüedad</label>
            <input v-model="family_member.time_worked" class="myImput" type="text" name="" id="">
          </div>
        </div>
        <div style="margin:24px; display:flex; justify-content: space-between;">
          <div style="display: flex; justify-content: center; align-items: normal; flex-direction: column;">
            <label for="">Turno de trabajo</label>
            <input v-model="family_member.schedule" class="myImput" type="text" name="" id="">
          </div>
          <div style="display: flex; justify-content: center; align-items: normal; flex-direction: column;">
            <label for="">¿Teletrabaja?</label>
            <input v-model="family_member.remote_work" :value="true" type="checkbox" name="" id="">
          </div>
        </div>

        <div style="height:100px;overflow:auto;" id="table">
          <table class="tableFamily">
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(family,index) in family_members" :key="family.name">
                <td>{{family.name}}</td>
                <td @click="edit(index)">✏️</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <!--Cuarto Formulario-->
      <div v-if="position == 4">
        <label for="" class="myLabel">Numeró de habitantes en la vivienda</label>
        <input v-model="candidate.family_counts" class="myImput" type="text" name="" id="">
        <label for="" class="myLabel">Numeró de hijos</label>
        <input v-model="candidate.sons_count" class="myImput" type="text" name="" id="">
        <label for="" class="myLabel">Tipo de vivienda</label>
        <div>
          <table>
            <tbody>
              <tr>
                <td style="width: 285px;">Casa</td>
                <td><input v-model="candidate.living_type" value="1" type="radio" name="" id=""></td>
              </tr>
              <tr>
                <td>Habitación</td>
                <td><input v-model="candidate.living_type" value="2" type="radio" name="" id=""></td>
              </tr>
              <tr>
                <td>Apartamento</td>
                <td><input v-model="candidate.living_type" value="3" type="radio" name="" id=""></td>
              </tr>
              <tr>
                <td>Otro</td>
                <td><input v-model="candidate.living_type" value="4" type="radio" name="" id=""></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <!-- Quinto Formulario-->
      <div v-if="position == 5">
        <label for="" class="myLabel">¿Tiene algún antecedente médico (Musculoesquelético) o psiquiátrico</label>
        <div style="margin:14px; display:grid;">
          <div>
            <label for="">Si</label>
            <input v-model="candidate.has_medical_antecedent" :value="true" type="radio" name="" id="">
            <label for="">No</label>
            <input v-model="candidate.has_medical_antecedent" :value="false" type="radio" name="" id="">
            <input placeholder="Ingresa tu respuesta" v-if="candidate.has_medical_antecedent" v-model="candidate.medical_antecedent" class="myImput" type="text" name="" id="">
          </div>
        </div>
        <label for="" class="myLabel">¿Ha sido incapacitado por enfermedad significativa en los últimos 6 meses?</label>
        <div style="margin:14px; display:grid;">
          <div>
            <label for="">Si</label>
            <input v-model="candidate.has_incapacitate_disease" :value="true" type="radio" name="" id="">
            <label for="">No</label>
            <input v-model="candidate.has_incapacitate_disease" :value="false" type="radio" name="" id="">
            <input placeholder="Ingresa tu respuesta" v-if="candidate.has_incapacitate_disease" v-model="candidate.incapacitate_disease" class="myImput" type="text" name="" id="">
          </div>
        </div>
        <label for="" class="myLabel">¿Se encuentra actualmente en tratamiento médico?</label>
        <div style="margin:14px; display:grid;">
          <div>
            <label for="">Si</label>
            <input v-model="candidate.has_medical_treatment" :value="true" type="radio" name="" id="">
            <label for="">No</label>
            <input v-model="candidate.has_medical_treatment" :value="false" type="radio" name="" id="">
            <input placeholder="Ingresa tu respuesta" v-if="candidate.has_medical_treatment" v-model="candidate.medical_treatment" class="myImput" type="text" name="" id="">
          </div>
        </div>
        <label for="" class="myLabel">Accidentes de tránsito, laborales y otros</label>
        <div style="margin:14px; display:grid;">
          <div>
            <label for="">Si</label>
            <input v-model="candidate.has_accidents" :value="true" type="radio" name="" id="">
            <label for="">No</label>
            <input v-model="candidate.has_accidents" :value="false" type="radio" name="" id="">
            <input placeholder="Ingresa tu respuesta" v-if="candidate.has_accidents" v-model="candidate.accidents" class="myImput" type="text" name="" id="">
          </div>
        </div>
      </div>
      <!-- Sexto Formulario-->
      <div v-if="position == 6">
        <label for="" class="myLabel">¿Consideras que cuentas con un espacio apropiado para teletrabajar?</label>
        <div style="margin:14px; display:grid;">
          <div>
            <label for="">Si</label>
            <input v-model="working_conditions.enviroment_condition" :value="true" type="radio" name="" id="">
            <label for="">No</label>
            <input v-model="working_conditions.enviroment_condition" :value="false" type="radio" name="" id="">
          </div>
        </div>
        <label for="" class="myLabel">¿Cuenta con una silla acorde para teletrabajar?</label>
        <div style="margin:14px; display:grid;">
          <div>
            <label for="">Si</label>
            <input v-model="working_conditions.chair_mobility_condition" :value="true" type="radio" name="" id="">
            <label for="">No</label>
            <input v-model="working_conditions.chair_mobility_condition" :value="false" type="radio" name="" id="">
          </div>
        </div>
        <label for="" class="myLabel">¿Cuál es el tamaño del escritorio en el que trabajas? (Puedes guiarte de las imagénes de referencia)</label>
        <div>
          <table>
            <tbody>
              <tr>
                <th><img src="https://static.kemikcdn.com/2015/11/nn.png" width="338px" alt="" srcset=""></th>
                <td><input v-model="working_conditions.desktop_dimensions_select" type="radio" value="1" name="" id=""></td>
              </tr>
              <tr>
                <th><img src="https://http2.mlstatic.com/D_NQ_NP_658821-MLA42702456114_072020-O.webp" width="338px" alt="" srcset=""></th>
                <td><input v-model="working_conditions.desktop_dimensions_select" type="radio" name="" value="2" id=""></td>
              </tr>
              <tr>
                <th><img src="https://i.ibb.co/xCpB46w/chair-2587847-960-720-removebg-preview.png" width="338px" alt="" srcset=""></th>
                <td><input v-model="working_conditions.desktop_dimensions_select" type="radio" name="" value="3" id=""></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div style="display:flex; justify-conten:center; align-items:center; flex-direction:column; margin-bottom:20px;" v-if="position == 6 && working_conditions.desktop_dimensions_select != 0" >
          <label class="myLabel" for="">Medidas del escritorio (Por favor ingrese las medidas de su escritorio)</label>
          <input type="text" class="myImput" v-model="working_conditions.desktop_dimensions" >
        </div>
        <label v-if="position == 6 && working_conditions.desktop_dimensions_select != 0" class="myLabel" for="">Carga de Archivos</label>
      <div style="display:flex; justify-conten:center; align-items:center; flex-direction:column;  margin-top:12px;" v-if="position == 6 && working_conditions.desktop_dimensions_select != 0">
        <label class="myLabel" for="">Imagen del escritorio (Por favor cargue una imagen de su escritorio)</label>
        <input type="file" id="desktopImage" name="" @change="uploadFile('desktopImage','Escritorio')" >
      </div>
       <br>
      <div style="display:flex; justify-conten:center; align-items:center; flex-direction:column;" v-if="position == 6 && working_conditions.desktop_dimensions_select != 0">
        <label class="myLabel" for="">Imagen de la silla (Por favor cargue una imagen de su silla)</label>
        <input type="file" id="chairImage" name="" @change="uploadFile('chairImage','Silla')" >
      </div>

      </div>
      <!-- Septimo Formulario-->
      <div v-if="position == 7">
        <label for="" class="myLabel">¿Cuál es la velocidad de internet con la que cuentas?</label>
        <div style="margin:14px; display:grid;">
          <div>
            <label for="">Mayor a 15mbps</label>
            <input v-model="candidate.internet_speed_select" value="1" type="radio" name="" id="">
            <label for="">Menor a 15mbps</label>
            <input v-model="candidate.internet_speed_select" value="2" type="radio" name="" id="">
          </div>
          <input placeholder="Velocidad de internet" style="margin-top: 10px;" v-if="candidate.internet_speed_select" v-model="working_conditions.internet_speed" class="myImput" type="text" name="" id="">
        </div>
        <label for="" class="myLabel">¿Cuentas con la iluminación adecuada para teletrabajar?</label>
        <div style="margin:14px; display:grid;">
          <div>
            <label for="">Si</label>
            <input v-model="working_conditions.lighting_adequate_condition" :value="true" type="radio" name="" id="">
            <label for="">No</label>
            <input v-model="working_conditions.lighting_adequate_condition" :value="false" type="radio" name="" id="">
          </div>
        </div>
        <label for="" class="myLabel">El área de trabajo, ¿posee fuentes internas o externas de ruido?</label>
        <div style="margin:14px; display:grid;">
          <div>
            <label for="">Si</label>
            <input v-model="working_conditions.external_noise_allows_work_condition" :value="true" type="radio" name="" id="">
            <label for="">No</label>
            <input v-model="working_conditions.external_noise_allows_work_condition" :value="false"  type="radio" name="" id="">
          </div>
        </div>
        <label for="" class="myLabel">¿Cuentas con computador?</label>
        <div style="margin:14px; display:grid;">
          <div>
            <label for="">Si</label>
            <input v-model="working_conditions.have_computer" :value="true" type="radio" name="" id="">
            <label for="">No</label>
            <input v-model="working_conditions.have_computer" :value="false" type="radio" name="" id="">
          </div>
        </div>
        <label for="" class="myLabel">¿Cuentas con camara web y microfono?</label>
        <div style="margin:14px; display:grid;">
          <div>
            <label for="">Si</label>
            <input v-model="working_conditions.have_microphonewebcan" :value="true" type="radio" name="" id="">
            <label for="">No</label>
            <input v-model="working_conditions.have_microphonewebcan" :value="false" type="radio" name="" id="">
          </div>
        </div>
      </div>
      <!-- Octavo Formulario-->
      <div v-if="position == 8">
        <label for="" class="myLabel">¿En cuál lugar de su vivienda está ubicado su escritorio?</label>
        <div>
          <table>
            <tbody>
              <tr>
                <td style="width: 285px;">Habitación</td>
                <td><input v-model="candidate.desktop_ubication" value="0" type="radio" name="" id=""></td>
              </tr>
              <tr>
                <td style="width: 285px;">Sala / Comedor</td>
                <td><input v-model="candidate.desktop_ubication" value="1" type="radio" name="" id=""></td>
              </tr>
              <tr>
                <td style="width: 285px;">Zona común</td>
                <td><input v-model="candidate.desktop_ubication" value="2" type="radio" name="" id=""></td>
              </tr>
              <tr>
                <td style="width: 285px;">Balcón / Terraza</td>
                <td><input v-model="candidate.desktop_ubication" value="3" type="radio" name="" id=""></td>
              </tr>
            </tbody>
          </table>
        </div>
        <label for="" class="myLabel">¿Te motiva teletrabajar?</label>
        <div style="margin:14px; display:grid;">
          <div>
            <label for="">Si</label>
            <input v-model="candidate.motivation_telework" value="Si" type="radio" name="" id="">
            <label for="">No</label>
            <input v-model="candidate.motivation_telework" value="No" type="radio" name="" id="">
          </div>
        </div>
        <label for="" class="myLabel">¿Cuáles considera que son los retos para trabajar en esta modalidad?</label>
        <div>
          <table>
            <tbody>
              <tr>
                <td>Manejo del tiempo</td>
                <td><input v-model="candidate.challenge_telework" value="Manejo del tiempo" type="checkbox" name="" id=""></td>
              </tr>
              <tr>
                <td>Respetar los espacios de trabajo con los familiares</td>
                <td><input v-model="candidate.challenge_telework" value="Respetar los espacios de trabajo con los familiares" type="checkbox" name="" id=""></td>
              </tr>
              <tr>
                <td>Productividad</td>
                <td><input v-model="candidate.challenge_telework" value="Productividad" type="checkbox" name="" id=""></td>
              </tr>
              <tr>
                <td>Distracciones que se presentan en el hogar</td>
                <td><input v-model="candidate.challenge_telework" value="Distracciones que se presentan en el hogar" type="checkbox" name="" id=""></td>
              </tr>
              <tr>
                <td>Dificultad para conectarse a trabajar</td>
                <td><input v-model="candidate.challenge_telework" value="Dificultad para conectarse a trabajar" type="checkbox" name="" id=""></td>
              </tr>
              <tr>
                <td>Otro</td>
                <td><input v-model="candidate.challenge_telework" value="Otro" type="checkbox" name="" id=""></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div style="display:flex; justify-conten:center; align-items:center; flex-direction:column; margin-bottom:20px;" v-if="position == 8 && candidate.challenge_telework.includes('Otro')" >
          <label class="myLabel" for="">Cuéntanos cual</label>
          <input type="text" class="myImput" v-model="anotherChallenge" >
        </div>

      </div>
      <!-- Noveno Formulario-->
      <div v-if="position == 9">
        <label for="" class="myLabel">'¿Ha tenido otras experiencias teletrabajando?</label>
        <div style="margin:14px; display:grid;">
          <div>
            <label for="">Si</label>
            <input v-model="candidate.experience_telework" value="Si" type="radio" name="" id="">
            <label for="">No</label>
            <input v-model="candidate.experience_telework" value="No" type="radio" name="" id="">
          </div>
        </div>
        <label for="" class="myLabel">¿Ves el teletrabajo como opción a futuro?</label>
        <div style="margin:14px; display:grid;">
          <div>
            <label for="">Si</label>
            <input v-model="candidate.future_in_remote_work" :value="true" type="radio" name="" id="">
            <label for="">No</label>
            <input v-model="candidate.future_in_remote_work" :value="false" type="radio" name="" id="">
          </div>
        </div>
        <label for="" class="myLabel">¿Presentas dificultades para teletrabajar por el número de personas con las que vives?</label>
        <div style="margin:14px; display:grid;">
          <div>
            <label for="">Si</label>
            <input v-model="candidate.difficulty_with_persons_number" :value="true" type="radio" name="" id="">
            <label for="">No</label>
            <input v-model="candidate.difficulty_with_persons_number" :value="false" type="radio" name="" id="">
          </div>
        </div>
        <label for="">¿Que tipo de impacto cree que tendría el teletrabajo en su dinámica familiar?</label>
        <input v-model="candidate.affect_family_telework" class="myImput" type="text" name="" id="">
        <label for="">¿Cómo espera utilizar el tiempo ganado con el teletrabajo?</label>
        <input v-model="candidate.social_aspects_free_time_activities" class="myImput" type="text" name="" id="">
      </div>
      <!-- Vista de agradecimiento-->
      <div v-if="position == 10 && viewAlert" id="greatingText">
        <p id="greatText">¡Muchas gracias por tu información!</p>
        <p id="explainGreat">
          Somos Globalwork. Una compañía que crea vínculos confiables en procesos <br> de selección a través de visitas domiciliarias y estudios de seguridad
        </p>

        <div v-if="viewAlert" id="aboutUs" style="position: relative; top: 25vh; text-align: center;">
          <img id="serviceImg" src="https://www.globalwork.co/wp-content/uploads/2020/05/icon-verificacion-antecedentes-home.svg" alt="">
          <p id="firstInformativeText">
            ¿Quieres saber más acerca de nuestros Estudios de Seguridad?  
          </p>
          <a id="secodnInformativeText" href="https://www.globalwork.co/">
            Conoce más de nuestro servicio
          </a>  
        </div>

      </div>
    </div>
    <!--Aca finalizan los forms-->



      <div class="" style="margin:24px; width:45%">
        <div>
          <button class="mybutton" v-if="position == 3 && editing" @click="saveChanges" id="saveChanges">Guardar Cambios</button>
          <button v-if="position == 3 && !editing" style="margin-bottom:7px;" class="mybutton" @click="addFamilyMember" id="saveReference">Agregar</button>          
          <button class="mybutton" v-if="!viewAlert && !viewProgress" @click="changeStep" id="saveReference">{{position == 0 ? 'Empezar' : 'Siguiente'}}</button>
        </div>
      </div>
    


    <loader v-if="viewProgress"/>
  </div>
</template>

<script>
import Autocomplete from './../../own/autocomplete-local'
import Loader from './../../own/loader'
import axios from 'axios'
export default {
  name:'WorkRemoteExpress',
  props:['cities','project','client'],
  data(){
    return{
      viewAlert:false,
      anotherChallenge:'',
      position:0,
      editing:false,
      family_members:[],
      titles:[
        '',
        '1/9: Cuéntanos sobre ti',
        '2/9: ¿Como podemos contactarte?',
        '3/9: Indícanos con quien vives y cuáles son sus ocupaciones',
        '4/9: Cuéntanos un poco sobre tu hogar',
        '5/9: Antecedentes médicos',
        '6/9: Condiciones mobiliarias para el teletrabajo',
        '7/9: Condiciones mobiliarias para el teletrabajo',
        '8/9: Motivaciones para el teletrabajo',
        '9/9: Motivaciones para el teletrabajo',
      ],
      step:0,
      working_conditions:{
        project_id:0,
        enviroment_condition:'',
        desktop_dimensions:'',
        chair_mobility_condition:'',
        have_microphonewebcan:'',
        have_computer:'',
        external_noise_allows_work_condition:'',
        lighting_adequate_condition:'',
        internet_speed:'',
        desktop_dimensions_select:0,
      },
      candidate:{
        id:0,
        current_activity:'',
        first_name:'Luis Jose',
        last_name: 'Torres Muñoz',
        birth_date:'06/03/1998',
        civil_type:0,
        neighborhood:'',
        email_1:'',
        telephone_1:'',
        address:'',
        challenge_telework:[]
      },
      viewProgress:false,
      family_member:{
        project_id:0,
        name:'',
        age:'',
        relation:'',
        civil_state:'',
        company:'',
        occupation:'',
        time_worked:'',
        schedule:'',
        remote_work:false
      },
      relationship:[
        {id:0, name:'Soltero/a'},
        {id:1, name:'Casado/a'},
        {id:2, name:'Viudo/a'},
        {id:3, name:'Unión libre'}
      ],
      familyRelations:[
        {id:0, name:'Hermano/a'},
        {id:1, name:'Hijo/a'},
        {id:2, name:'Padre/Madre'},
        {id:3, name:'Tio/a'},
        {id:4, name:'Abuelo/a'},
        {id:5, name:'Primo/a'},
        {id:6, name:'Sobrino/a'},
        {id:7, name:'Amigo/a'},
        {id:8, name:'Esposo/a'},
        {id:9, name:'Suegra/o'},
        {id:10, name:'Cuñado/a'},
        {id:11, name:'Otro'},
      ]
    }
  },
  methods:{
    async changeStep(){
      const token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
			axios.defaults.headers['x-csrf-token'] = token
			axios.defaults.headers.common['Accept'] = 'application/json';
      axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
      this.position += 1
      if(this.position == 2){
        setTimeout(() => {
          document.getElementById('inputCity').className = "myImput"
          document.getElementById('inputCity').placeholder = "Ingrese nombre de ciudad"
        }, 50);
      }

      if(this.position == 4){
        this.viewProgress = true
        await this.registerFamily()
        this.viewProgress = false
      }

      if(this.position == 8){
        this.viewProgress = true
        await axios.put(`/remote_work_express/${this.project.id}`,{working:this.working_conditions,type:'conditions'})
        this.viewProgress = false
      }

       else if (this.position == 10){
         this.viewProgress = true
         let element = ''
         for (let i = 0; i < this.candidate.challenge_telework.length; i++) {
           this.candidate.challenge_telework[i] == 'Otro' ? element += ' ' + this.anotherChallenge 
           : element += ' ' + this.candidate.challenge_telework[i]
         }
         this.candidate.challenge_telework = element
         await axios.put(`/remote_work_express/${this.project.id}`,{project:this.candidate,type:'project'})
         this.viewProgress = false
         this.viewAlert = true
       }

    },
    registerFamily(){
      return new Promise((resolve,reject)=> {
        axios.put(`/remote_work_express/${this.project.id}`,{members:this.family_members, type:'member'})
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
      })
    },
    addFamilyMember(){
      this.family_member.project_id = this.project.id
      let new_family = Object.assign({},this.family_member)
      this.family_members.push(new_family)
      this.cleanObject(this.family_member)
    },
    cleanObject(object){
      const keys = Object.keys(object)
      console.log(keys)
      for (let i = 0; i < keys.length; i++) {
        object[keys[i]] = ''
      }
    },
    edit(position){
      let element = this.family_members[position]
      const newObject = Object.assign(this.family_member,element)
      this.editing = true
      this.step = position
    },
    saveChanges(){
      let new_family = Object.assign({},this.family_member)
      this.family_members[this.step] = new_family
      this.cleanObject(this.family_member)
      this.editing = false
    },

    toBase64(file) {
      return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
      })
    },

    async uploadFile(id,name){
      let imput = document.querySelector(`#${id}`).files[0];
      const file = await this.toBase64(imput)
      const result = await axios.put(`/remote_work_express/${this.project.id}`,{file:file,type:'file',name:name})
      console.log(result)
      
    },
    checkedElement(id){
      let element = document.getElementById(id)
      element.checked = true
      this.working_conditions.challenge_telework += element.value
    }
  },
  components:{
    'autocomplete':Autocomplete,
    'loader':Loader
  },
  created(){
    this.candidate.first_name = this.project.first_name
    this.candidate.id = this.project.id
    this.candidate.last_name = this.project.last_name
    this.candidate.current_activity = this.project.current_activity
    this.candidate.birth_date = this.project.birth_date
    this.candidate.civil_type = this.project.civil_type
    this.candidate.email_1 = this.project.email_1
    this.working_conditions.project_id = this.project.id
    this.candidate.telephone_1 = this.project.telephone_1
    if(this.project.status == 6){
      this.position = 10
      this.viewAlert = true
    }
  }

}
</script>

<style scoped>

</style>